import { FormControl, MenuItem, Select } from '@mui/material';
import { useGroup } from '../contexts/GroupContext.jsx';

export const GroupSwitcher = ({ size = 'small', sx }) => {
  const { groups, activeGroupId, setActiveGroupId, loading } = useGroup();

  // Guide-sandbox workspaces are hidden unless the sandbox is currently the
  // active workspace - the user needs to see they are in the practice space
  // and have a way to switch back to a real workspace (#831).
  const visibleGroups = groups.filter(
    (g) => !g.guideSandbox || g.groupId === activeGroupId,
  );

  if (loading || visibleGroups.length <= 1) return null;

  // Workspace creation lives in the Account page, not the top bar (#1289).
  // v4 (#1377): the board Field look (surface-2 fill, hairline, input radius).
  // The switcher itself is a documented deviation - the board never modeled
  // workspace switching; owner chose to keep it in the bar. #1401: the
  // floating label is dropped so the field fits the 44px board bar; the
  // accessible name moves to aria-label.
  return (
    <FormControl size={size} sx={sx} data-tour-id="workspace-switcher">
      <Select
        value={activeGroupId || ''}
        onChange={(e) => setActiveGroupId(e.target.value)}
        inputProps={{ 'aria-label': 'Workspaces' }}
        sx={(theme) => ({
          backgroundColor: theme.palette.surface.hover,
          borderRadius: `${theme.ds.radius.pill}px`,
          fontSize: '13px',
          // #1405: hard-bound the input so the fixed 44px bar always holds
          // (explicit line-height; MUI's em-based default tracks font size).
          '& .MuiSelect-select': { paddingTop: '4px', paddingBottom: '4px', lineHeight: '20px', minHeight: 0 },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.divider },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.borderStrong },
        })}
      >
        {visibleGroups.map(g => (
          <MenuItem key={g.groupId} value={g.groupId}>{g.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GroupSwitcher;
